module.exports = __webpack_public_path__ + "static/media/Sidebar-currency-protect-icon-active.e9f40b16.svg";